import { ResidencyStatus } from "@/constants/PersonConstants";
import { ContractType } from "@/constants/EmploymentType";

export default class CreateRIDCContractorPayload {

  contractorId: number | null = null;
  name: string | null = null;
  phone: string | null = null;
  email: string | null = null;
  actualizationOnly = false;
  contractStart!: Date;
  branchesId: number[] = [];
  contractType!: ContractType;

  // if it has already been registered
  ssnRequired = true;
  stateIdRequired = true;
  eadRequired = true;
  greenCardRequired = true;
  citizenPassportRequired = true;
  bankDetailsRequired = true;
  residencyStatus?: ResidencyStatus;

  constructor(init?: Partial<CreateRIDCContractorPayload>) {
    Object.assign(this, init);
  }

}
